import { render, staticRenderFns } from "./dp-count.vue?vue&type=template&id=27ef16dc&scoped=true"
import script from "./dp-count.vue?vue&type=script&lang=js"
export * from "./dp-count.vue?vue&type=script&lang=js"
import style0 from "./dp-count.vue?vue&type=style&index=0&id=27ef16dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef16dc",
  null
  
)

export default component.exports